import { render, staticRenderFns } from "./closed.vue?vue&type=template&id=1f296a7c&scoped=true&"
import script from "./closed.vue?vue&type=script&lang=js&"
export * from "./closed.vue?vue&type=script&lang=js&"
import style0 from "./closed.vue?vue&type=style&index=0&id=1f296a7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f296a7c",
  null
  
)

export default component.exports